import React from 'react';

export const BulletList = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M9 17.25C9 16.8358 9.33579 16.5 9.75 16.5L19.25 16.5C19.6642 16.5 20 16.8358 20 17.25C20 17.6642 19.6642 18 19.25 18L9.75 18C9.33579 18 9 17.6642 9 17.25Z"
      fill="black"
      fillRule="evenodd"
    />
    <circle cx="5.25" cy="17.25" fill="black" r="1.25" />
    <path
      clipRule="evenodd"
      d="M9 12.25C9 11.8358 9.33579 11.5 9.75 11.5L19.25 11.5C19.6642 11.5 20 11.8358 20 12.25C20 12.6642 19.6642 13 19.25 13L9.75 13C9.33579 13 9 12.6642 9 12.25Z"
      fill="black"
      fillRule="evenodd"
    />
    <circle cx="5.25" cy="12.25" fill="black" r="1.25" />
    <path
      clipRule="evenodd"
      d="M9 7.25C9 6.83579 9.33579 6.5 9.75 6.5L19.25 6.5C19.6642 6.5 20 6.83579 20 7.25C20 7.66421 19.6642 8 19.25 8L9.75 8C9.33579 8 9 7.66421 9 7.25Z"
      fill="black"
      fillRule="evenodd"
    />
    <circle cx="5.25" cy="7.25" fill="black" r="1.25" />
  </svg>
);
